import React, { useState, useEffect } from "react";
import '../styles/tiles.css';
import '../styles_m/tiles_m.css';
import '../styles/other.css';
import Axios from 'axios';
import { Link, Navigate, useLocation } from "react-router-dom";
import { navigate } from "@reach/router";

// import utilities
import { checkForErrorsInRequest } from '../utilities/RequestsUtilities.js';

// import assets
import background from '../assets/background.jpg';

// import components
import RoundButton from '../components/RoundButton.js';

class ApplicationTile extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            mainFundingId: 0,
        }
    }

    componentDidMount(){
        this.setState({ redirectTo: null });

        const pathname = this.props.location.pathname;
        var id = pathname.substring(pathname.lastIndexOf("/")+1);
        if(id.includes("?")){ id = id.substring(0, id.indexOf("?")); }
        if(Number.isInteger(Number(id)))this.setState({ mainFundingId: parseInt(id) });

        //this.loadData();
    }

    loadData = async () => {

    }

    render() {
        return (
            <div className="universalLeftTileWithTable" style={{marginBottom: 20}}>

                {/* FIRST PART OF TILE WITH BACKGROUND */}
                <div className="flex" style={{flex: 1, height: 100, position: "relative"}}>

                    <div style={{width: "calc(100% + 40px)", backgroundColor: "var(--full-black)", height: "100%", position: "absolute", zIndex: 0, marginLeft: "-20px", marginTop: "-15px", borderRadius: "20px 20px 0px 0px"}}>
                        <img style={{width: "100%", height: "100%", borderRadius: "25px 25px 0px 0px", objectFit: "cover", opacity: 1}} src={background}/>
                    </div>

                    <div className="horizontalStack" style={{height: "100%"}}>

                        <div className="verticalStack flex" style={{zIndex: "0", height: "100%"}}>
                            <div className="verticalStackCenter flex" style={{height: "100%", marginTop: "-20px"}}>
                                <div className="horizontalStack" style={{height: "100%"}}>
                                    <div className="verticalStackCenter" style={{minWidth: 50, height: "100%"}}>
                                        <div className="flex"></div>
                                        <div className="responsiveThreeDotsContainer">
                                            <span className="fontPoppinsSemiBold13White responsiveThreeDots"><b>{"Application for project with ID "+this.state.mainFundingId+":"}</b></span>
                                        </div>
                                        <div className="responsiveThreeDotsContainer">
                                            <span className="fontPoppinsSemiBold20White responsiveThreeDots"><b>{"Online Influencer Studio"}</b></span>
                                        </div>
                                        <div className="flex"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                {/* SECOND PART OF TILE ABOUT PROJECT */}
                <div className="horizontalStack" style={{position: "relative", width: "100%"}}>

                    <div className="verticalStack" style={{flex: 1, minWidth: 50}}>
                        <span className="fontPoppinsSemiBold15" style={{marginBottom: 10}}>Info about the project:</span>
                        <span className="fontPoppinsRegular13DarkGray">Country: <span className="fontPoppinsRegular13Gray">Croatia</span></span>
                        <span className="fontPoppinsRegular13DarkGray">Priority: <span className="fontPoppinsRegular13Gray">High</span></span>
                        <span className="fontPoppinsRegular13DarkGray">Created By: <span className="fontPoppinsRegular13Gray">John Smith</span></span>
                        <span className="fontPoppinsRegular13DarkGray">Created Date: <span className="fontPoppinsRegular13Gray">June 6, 2024</span></span>
                    </div>

                    <div className="verticalStackCenter">
                        <div style={{width: 1, height: "100%", backgroundColor: "var(--light-purple-gray)", marginRight: 20}}></div>
                    </div>

                    <div className="verticalStack" style={{flex: 1, minWidth: 50}}>
                        <div className="flex"></div>
                        <span className="fontPoppinsRegular13DarkGray">{"Note:"}</span>
                        <span className="fontPoppinsRegular13Gray">{"This is some very important note about this project, maybe describing why we need some funds for this reason or some another important notes."}</span>
                        <div className="flex"></div>
                    </div>
                </div>

               {/* THIRD PART OF TILE ABOUT APPLICATION */}
                <div className="horizontalStack" style={{position: "relative", width: "100%", marginTop: 20}}>

                    <div className="verticalStack" style={{flex: 1, minWidth: 50}}>
                        <span className="fontPoppinsSemiBold15" style={{marginBottom: 10}}>Info about the application:</span>
                        <span className="fontPoppinsRegular13DarkGray">Requested Amount: <span className="fontPoppinsRegular13Gray">$5 500</span></span>
                        <span className="fontPoppinsRegular13DarkGray">Approved Amount: <span className="fontPoppinsRegular13Gray">waiting</span></span>
                        <span className="fontPoppinsRegular13DarkGray">Grant Name: <span className="fontPoppinsRegular13Gray">July 24 Round</span></span>
                    </div>

                    <div className="verticalStackCenter">
                        <div style={{width: 1, height: "100%", backgroundColor: "var(--light-purple-gray)", marginRight: 20}}></div>
                    </div>

                    <div className="verticalStack" style={{flex: 1, minWidth: 50}}>
                        <div className="flex"></div>
                        <span className="fontPoppinsRegular13DarkGray">{"Note:"}</span>
                        <span className="fontPoppinsRegular13Gray">{"This is some very important note about this application, maybe describing why we need some funds for this reason or some another important notes."}</span>
                        <div className="flex"></div>
                    </div>
                </div>

                <div className="horizontalStack" style={{paddingLeft: 0, marginTop: 20, paddingRight: 0, paddingBottom: 0}}>
                    <div className="verticalStackCenter" style={{backgroundColor: "var(--jv-orange)", borderRadius: 20}}>
                        <span className="fontPoppinsRegular13" style={{color: "white", top: "50%", paddingLeft: 20, paddingRight: 20}}>{"Status: Funding Identified"}</span>
                    </div>
                    <RoundButton title={"Delete"} className={"roundButtonGray"} onClick={this.editExistingRole} whiteText={true} style={{marginLeft: 10}} />
                </div>

            </div>
        );
    }
}

const withLocation = Component => props => {
    const location = useLocation();

    return <Component {...props} location={location} />;
};

export default withLocation(ApplicationTile);
